export default __webpack_public_path__ + "static/media/person-no-bg.334fc871.svg";